import { useLang } from "@/i18n/LanguageContext";

export default function Marquee() {
    const { t } = useLang();
    const ITEMS = t("home.marquee");
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            aria-hidden="true"
            className="overflow-hidden border-y border-gray-100 bg-white py-6 select-none"
        >
            <div className="marquee-track flex items-center gap-12 whitespace-nowrap w-max">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center gap-12">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center gap-12">
                                <span className="font-display text-lg md:text-xl font-medium text-weyb-ink/40 hover:text-weyb-ink transition-colors">
                                    {item}
                                </span>
                                <span className="h-1.5 w-1.5 rotate-45 bg-weyb-yellow" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
